import Column, { ColumnProps } from 'antd/lib/table/Column';
// export default ConfiguredColumn;
export default Column;
